import { render, staticRenderFns } from "./HistoricoInativacao.vue?vue&type=template&id=c7e45cb0&scoped=true"
import script from "./HistoricoInativacao.vue?vue&type=script&lang=js"
export * from "./HistoricoInativacao.vue?vue&type=script&lang=js"
import style0 from "./HistoricoInativacao.vue?vue&type=style&index=0&id=c7e45cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e45cb0",
  null
  
)

export default component.exports